import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import './Main.css';
import { FaCloudUploadAlt } from "react-icons/fa";
import Background from './Background';
import { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { OPTIONAL_FIELDS, FIELD_LABELS } from './serviceFieldConfig';

const API_BASE = 'https://api.connecker.com/api';

function AddServiceType() {
    const history = useHistory();
    const [cookies] = useCookies(['user']);
    const [name, setName] = useState("");
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [allowedFields, setAllowedFields] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const toggleAllowedField = (field) => {
        setAllowedFields(prev =>
            prev.includes(field) ? prev.filter(f => f !== field) : [...prev, field]
        );
    };

    const onDrop = useCallback(acceptedFiles => {
        if (acceptedFiles && acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            setImageFile(file);
            const reader = new FileReader();
            reader.onload = (e) => {
                setImagePreview(e.target.result);
            };
            reader.readAsDataURL(file);
        }
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.webp', '.svg']
        },
        maxFiles: 1
    });

    const createServiceTypeAPI = () => {
        if (!name || !name.trim()) {
            toast.error("Please enter a service type name");
            return;
        }

        var data = new FormData();
        data.append("name", name.trim());
        if (imageFile) {
            data.append("image", imageFile);
        }
        allowedFields.forEach(field => {
            data.append("allowed_fields[]", field);
        });

        setIsLoading(true);
        fetch(`${API_BASE}/create_service_type`, {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': `Bearer ${cookies.token}`
            }
        }).then(res => res.json()).then(data => {
            setIsLoading(false);
            if (data.response_code === 200) {
                toast.success(data.message);
                setTimeout(() => {
                    history.push('/services');
                }, 1000);
            } else {
                toast.error(data.message || 'Failed to create service type');
            }
        }).catch(() => {
            setIsLoading(false);
            toast.error('Failed to create service type');
        });
    };

    return (
        <div className="content">
            <div className="row d-flex justify-content-center">
                <div className="col-2 col-sm-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-10 col-sm-10" style={{ paddingLeft: "40px" }}>
                    <Background></Background>
                    <h4 style={{ color: "white", marginTop: "50px" }}>Add Service Type</h4>
                    <div className="card" style={{ width: "100%" }}>
                        <div className="card-body">
                            <div className="d-flex">
                                <h6 style={{ color: "orange" }}>Basic</h6>
                                &nbsp;
                                <h6>Information</h6>
                            </div>
                            <br></br>

                            <div className="mb-3">
                                <label className="form-label" style={{ marginBottom: "8px", fontWeight: "500" }}>Name *</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ border: "1px solid lightgrey", borderRadius: "25px", padding: "10px", width: "17rem" }}
                                    placeholder="Service type name (e.g. Notaries)"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label" style={{ marginBottom: "8px", fontWeight: "500" }}>Allowed Fields (optional)</label>
                                <p className="text-muted small mb-2">Select which extra fields to show when creating/viewing services of this type. Base fields (name, phone, email, address, image) are always shown.</p>
                                <div className="d-flex flex-wrap gap-2">
                                    {OPTIONAL_FIELDS.map(field => (
                                        <label key={field} className="d-inline-flex align-items-center gap-1 me-3 mb-1" style={{ cursor: 'pointer' }}>
                                            <input
                                                type="checkbox"
                                                checked={allowedFields.includes(field)}
                                                onChange={() => toggleAllowedField(field)}
                                            />
                                            <span style={{ fontSize: "14px" }}>{FIELD_LABELS[field] || field}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>

                            <div className="mb-3">
                                <label className="form-label" style={{ marginBottom: "8px", fontWeight: "500" }}>Image (optional)</label>
                                {imagePreview && (
                                    <div className="mb-2">
                                        <img
                                            src={imagePreview}
                                            alt="Preview"
                                            style={{
                                                width: "200px",
                                                height: "120px",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                                border: "1px solid #ddd"
                                            }}
                                        />
                                    </div>
                                )}
                                <div {...getRootProps()} className="container" style={{ borderRadius: "16px", height: "12rem", backgroundColor: "#FCC981", cursor: "pointer" }}>
                                    <input {...getInputProps()} />
                                    {!isDragActive ? (
                                        <center>
                                            <FaCloudUploadAlt style={{ width: "5rem", height: "5rem", color: "#FF4500" }}></FaCloudUploadAlt>
                                            <br></br><br></br>
                                            <h5><b>Drop Files Or Click To Upload</b></h5>
                                        </center>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>

                            <br></br>
                            <button
                                onClick={() => createServiceTypeAPI()}
                                disabled={isLoading}
                                style={{
                                    color: "white",
                                    backgroundColor: "#FF4500",
                                    border: "1px solid #FF4500",
                                    borderRadius: "25px",
                                    padding: "10px",
                                    paddingLeft: "40px",
                                    paddingRight: "40px",
                                    margin: "5px",
                                    opacity: isLoading ? 0.6 : 1,
                                    cursor: isLoading ? "not-allowed" : "pointer"
                                }}
                            >
                                {isLoading ? 'Submitting...' : 'Submit'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

export default AddServiceType;
